import axios from "axios"

export function createBulkProduct(payload) {
  return new Promise((resolve, reject) => {
    axios.post("/serialnumber/api/v1/product/bulk-create", payload)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}